export class FetchReviewedDocumentationCommand {
  private _userId: string
  private _procedureCode: string

  constructor (userId: string, procedureCode: string) {
    this._userId = userId
    this._procedureCode = procedureCode
  }

  userId (): string {
    return this._userId
  }

  procedureCode (): string {
    return this._procedureCode
  }
}
